import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { RouterModule } from "@angular/router";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { DragDropModule } from "@angular/cdk/drag-drop";
import { SharedModule } from "../shared-module/shared.module";
import { UserAdminRoutingModule } from "./user-admin-routing.module";

import { UserAdminComponent } from "./pages";
import { UserFormComponent } from "./components";
import { SecurityGroupFilterPipe } from "./pipes/security-group-filter.pipe";
import { TeamAdminComponent } from './pages/team-admin/team-admin.component';
import { TeamFormComponent } from './components/team-form/team-form.component';
import { UserCardComponent } from './components/user-card/user-card.component';
import { TeamCardComponent } from './components/team-card/team-card.component';

@NgModule({
  declarations: [UserAdminComponent, UserFormComponent, SecurityGroupFilterPipe, TeamAdminComponent, TeamFormComponent, UserCardComponent, TeamCardComponent],
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    DragDropModule,
    SharedModule,
    UserAdminRoutingModule
  ],
  exports: [UserAdminComponent, UserFormComponent]
})
export class UserAdminModule {}
